import { BrowserRouter as Router } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import { SkeletonTheme } from 'react-loading-skeleton'
import { init } from '@amplitude/analytics-browser'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import theme from '@frete.com/fuel-foundation/fretebras/theme.json'
import Routes from '~routes'
import GlobalStyle from '~assets/styles/global'
import '@frete.com/fuel-foundation/fretebras/main-fontface.css'
import 'react-loading-skeleton/dist/skeleton.css'
import { useEffect } from 'react'

function App(): JSX.Element {
  init(process.env.REACT_APP_AMPLITUDE_API_KEY)
  useEffect(() => {
    localStorage.setItem('threatmetrix_id', window?.session_id)
  }, [])

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_GOOGLE_RECAPTCHA}
      useEnterprise={true}
    >
      <Router>
        <ThemeProvider theme={theme}>
          <SkeletonTheme baseColor="#DADEE7" highlightColor="#F3F4F6">
            <GlobalStyle />
            <Routes />
          </SkeletonTheme>
        </ThemeProvider>
      </Router>
    </GoogleReCaptchaProvider>
  )
}

export default App
